var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-striped border-0"},[_c('app-table-header',{staticClass:"bg-primary text-white"},[_vm._t("header")],2),_vm._t("default"),(_vm.hasFooter)?_c('app-table-footer',{staticClass:"bg-primary text-white"},[_vm._t("footer")],2):_vm._e()],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }